const stappSolutionsUrls = {
    "de-de": "https://www.stappsolutions.de",
};

export const getStappSolutionsUrl = (locale) =>
    stappSolutionsUrls[locale] ?? "https://stapp.solutions";
